import { Component, OnInit, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';

import { filter, map, catchError, finalize, switchMap, tap } from 'rxjs/operators';

import { ReCaptchaV3Service } from 'ngx-captcha';
import { PaymentService } from '../payment.service';

import { environment } from '../http/environment';
import { Subscription, EMPTY } from 'rxjs';

@Component({
   selector: 'app-confirmation',
   templateUrl: './confirmation.component.html',
   styleUrls: ['./confirmation.component.scss']
})
export class ConfirmationComponent implements OnInit, OnDestroy {

   uuid: string;
   decision: string;
   ref: string;

   error = false;
   show_email = false;
   sending = false;
   email = new FormControl('', [ Validators.required, Validators.email ]);

   subs: Subscription;

   constructor(
      private route: ActivatedRoute,
      private router: Router,
      private payment: PaymentService,
      private changes: ChangeDetectorRef,
      private recaptcha: ReCaptchaV3Service,
   ) {
      this.subs = new Subscription();
      this.uuid = '';
      this.decision = '';
      this.ref = '';
   }

   ngOnInit() {
      this.subs.add(
         this.route.params.pipe(
            filter( params => params?.number ),
            map( params => params.number ),
            tap( uuid => this.uuid = uuid ),
            switchMap( uuid => this.payment.getDetails( uuid ) ),
            catchError( err => {
               this.error = true;
               console.log( 'got response error', this.firstErrorMessage( err ) );

               setTimeout( _ => this.router.navigate([ '/' ]), 3000 );

               return EMPTY;
            }),
         ).subscribe( response => {
            this.decision = response.decision;
            this.ref = response.ref;
         }),
      );
   }

   ngOnDestroy() {
      this.email.reset();
      this.subs.unsubscribe();
   }

   check() {
      if ( this.email.invalid ) { return; }

      if ( !environment.production ) { return this.send(); }

      this.recaptcha.execute('6LchSnAUAAAAAMAHgohw2X1xgDNIEEqzf4p9gQBE', 'paymentEmail', token => {
         if ( token ) {
            this.send();
         } else {
            this.email.setErrors({ fail: true });
            this.changes.detectChanges();
         }
      });
   }

   send() {
      if ( this.email.invalid || this.sending ) { return; }

      this.sending = true;
      this.subs.add(this.payment.sendEmail({ uuid: this.uuid, address: this.email.value }).pipe(
         catchError( err => {
            const message = this.firstErrorMessage( err );

            if ( message ) {
               this.email.setErrors({ message });
            } else {
               this.email.setErrors({ fail: true });
            }
            this.email.markAsTouched();

            throw err;
         }),
         finalize( () => {
            this.sending = false;
            this.changes.detectChanges();
         }),
      ).subscribe({
         next: () => {
            this.email.reset();
            this.show_email = false;
         },
         error: () => { },
      }));
   }

   private firstErrorMessage( err: any ): string {
      return err.error?.messages?.[0]?.message;
   }
}
